export default __webpack_public_path__ + "static/3-18-0-0-94c69a87dc817398947061308115a87f.jpg";